/**
 * Parses a digit-only string as a canonical page number: an exact safe integer >= 2
 * that round-trips back to the same string (guards against values like `1e+25` or `Infinity`
 * that `Number()` would otherwise coerce to a different string representation).
 */
export const parseSafePageNumber = (value: string): number | null => {
  const page = Number(value);
  return Number.isSafeInteger(page) && page >= 2 && String(page) === value ? page : null;
};
